import { render, staticRenderFns } from "./ProjectsTableSmall.vue?vue&type=template&id=90fba8f8"
import script from "./ProjectsTableSmall.vue?vue&type=script&lang=ts"
export * from "./ProjectsTableSmall.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsTableSmall.vue?vue&type=style&index=0&id=90fba8f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports